<template>
  <div>
    <card-total class="card-total">
      <div slot="title">
        <div class="cardCustom__header">
          <div class="cardCustom__header-text">
            <span class="uppercase">
              {{ title }}
            </span>
          </div>
          <div class="cardCustom__header-info__item">
            <button
              v-tooltip="{
                content: infoText,
                placement: 'bottom-center',
                classes: ['info'],
              }"
            >
              <i class="fas fa-info-circle" />
            </button>
          </div>
        </div>
      </div>

      <div slot="content" class="content pt-3 pb-3">
        <div v-if="loading" :class="{ bgBlur: true }" :style="blurStyles"></div>
        <div v-if="loading" class="loadingSection lds-dual-ring"></div>
        <div class="row justify-content-center align-items-center text-center flex-column">
          <span class="total-title mb-3">Summary</span>
          <pie-chart class="cardCustom__chart" :chartData="chartData" :options="options" :styles="myStyles"></pie-chart>
        </div>
        <div class="row"></div>
        <div class="row"></div>
        <div class="row"></div>
        <div class="row text-center flex-column mt-5">
          <ProgressBarSecondary
            class="manage-company-answers__progressBar"
            title="Progress"
            :color="progressBarColor"
            :loading="loading"
            :progress="progress"
            :total="total"
            :button-reload="false"
            unit_name=""
          >
          </ProgressBarSecondary>
        </div>
      </div>
    </card-total>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import CardSummary from '@/components/Cards/CardSummary';
import CardTotal from '@/components/Cards/CardTotal';
import DefineValueClass from '@/controllers/Class/DefineValueClass';
import ProgressBarSecondary from '@/components/Bars/ProgressBarSecondary';
import PieChart from '@/controllers/Charts/PieChart';

export default {
  name: 'DashboardElementTotal',
  components: { PieChart, ProgressBarSecondary, CardTotal, CardSummary, MoonLoader },
  props: {
    loading: Boolean,
    summary: Array,
    answers: Object,
    questions: Object,
    questionnaireScoreByColor: Object,
    footerText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Total Summary',
    },
    subTitle: {
      type: String,
      default: '',
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
          position: 'bottom',
        },
        title: {
          display: true,
          text: 'Chart.js Pie Chart',
        },
      },
    },
    progressBarColor: {
      type: String,
      default: 'green',
    },
    infoText: {
      type: String,
      default: 'Total achieved score of questionnaire',
    },
    total: Number,
    progress: Number,
  },
  data() {
    return {
      summaryCopy: null,
      categoryCopy: null,
      totalScore: null,
      valueClass: null,
      chartData: null,
      totalQuestions: null,
      answeredQuestions: null,
    };
  },
  computed: {
    myStyles() {
      return {
        height: `${220}px`,
        weight: `${210}px`,
        position: 'relative',
      };
    },
    blurStyles() {
      return {
        height: `100%`,
      };
    },
  },
  mounted() {
    this.setChartData();
    this.updateChartId();
  },
  methods: {
    getValueClass() {
      return 'success';
    },
    async getTotalScore() {
      let totalQuestions = 0;
      let answeredQuestions = 0;

      this.summary.forEach((element) => {
        totalQuestions += element.green + element.grey + element.yellow + element.red;
        answeredQuestions += element.green + element.yellow + element.red;
      });

      this.totalQuestions = totalQuestions;
      this.answeredQuestions = answeredQuestions;
    },
    async setTotalScore(totalScore) {
      this.totalScore = totalScore;
    },
    defineValueClass(totalScore) {
      this.valueClass = DefineValueClass.defineClass(totalScore);
      return this.valueClass;
    },
    getStars() {
      return DefineValueClass.defineStars(this.totalScore);
    },
    /***
     * Initializes the chart by merging the chart options sent via props and the default chart options
     */
    initChart(Chartist) {
      const chartIdQuery = `#${this.chartId}`;
      Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions);
    },
    /***
     * Assigns a random id to the chart
     */
    updateChartId() {
      const currentTime = new Date().getTime().toString();
      const randomInt = this.getRandomInt(0, currentTime);
      this.chartId = `div_${randomInt}`;
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    setChartData() {
      this.chartData = {
        labels: this.questionnaireScoreByColor.labels,
        datasets: [
          {
            data: this.questionnaireScoreByColor.series,
            backgroundColor: ['#73AB6B', '#F3BB44', '#EB5E28', '#D8D5D5', '#A4D1DE'],
          },
        ],
      };
    },
  },
};
</script>

<style scoped></style>
